// extracted by mini-css-extract-plugin
export default {"ant-page-header":"styles_ant-page-header__0nj4X","ant-page-header-heading-title":"styles_ant-page-header-heading-title__u+Viu","table":"styles_table__pmUSk"};